import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import TrackerBoard from './TrackerBoard/TrackerBoard';

import styles from './TrackerTabs.module.scss';

const TrackerTabs = ({ tab = 'sent-jobs' }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleTabChange = (newTab) => {
    navigate(`/tracker/${newTab}`);
  };

  return (
    <div className={styles.container}>
      <Tabs
        unmountOnExit
        activeKey={tab}
        transition={false}
        id="tracker-section-tabs"
        className={styles.tabs}
        onSelect={handleTabChange}
      >
        <Tab eventKey="sent-jobs" title={t('tracker.sentReferrals', 'Sent Referrals')}>
          <TrackerBoard direction="their" />
        </Tab>
        <Tab eventKey="my-jobs" title={t('tracker.receivedReferrals', 'Received Referrals')}>
          <TrackerBoard direction="my" />
        </Tab>
      </Tabs>
    </div>
  );
};

export default TrackerTabs;
